export const wafItems = [
  {
    title: "تیم تحلیل امنیتی",
    desc: "تحلیلگران امنیتی، مجهز به دانش روز برای شناخت دقیق الگوهای حمله، برای شناسایی، بررسی و واکنش سریع به رخدادها، مستقر در مرکز عملیات امنیت",
  },
  {
    title: "ابزارهای پیشرفته",
    desc: "فناوری‌های SIEM ،XDR و DLP برای رصد و تحلیل داده‌ها، به‌همراه سیستم‌های IDS و IPS برای مقابله با نفوذ در لایه‌های مختلف شبکه",
  },
  {
    title: "فرایند‌های ساختاریافته",
    desc: "چرخه‌ چهارمرحله‌ایِ شناسایی، تحلیل، مهار تهدید و بازیابی، در کنار راهکارهای امن‌سازی سیستم‌ها (Hardening) برای افزایش تاب‌آوری امنیتی سازمان",
  },
];

export const serviceFeatures = [
  {
    title: "سامانه‌های مدیریت و تحلیل رخداد",
    specialChar: "(SIEM)",
    desc: "جمع‌آوری گزارش‌ها و لاگ‌ها از سامانه‌های امنیتی، تجهیزات زیرساختی و اپلیکیشن‌ها، همچنین تحلیل مبتنی بر هوش مصنوعی و تطبیق رفتارهای مشکوک با الگوهای حملات قبلی برای شناسایی سریع رخدادهای امنیتی و تهیه گزارش‌های تحلیلی بلادرنگ",
    logo: "Feature-6.svg",
    imgAlt: "سامانه‌های مدیریت و تحلیل رخداد (SIEM)",
    imgTitle: "سامانه‌های مدیریت و تحلیل رخداد (SIEM)",
  },
  {
    title: "سامانه‌های شناسایی و پاسخ",
    specialChar: "(XDR)",
    desc: "دریافت و تجمیع داده‌های امنیتی از طریق ایجنت‌های چندلایه شامل NDR (ترافیک شبکه) و EDR (ترافیک نقاط پایانی) برای شناسایی تهدیدات پیشرفته، تحلیل خودکار رخدادها و اجرای پاسخ هماهنگ در سطح کل زیرساخت",
    logo: "Feature-3.svg",
    imgAlt: "سامانه‌های شناسایی و پاسخ (XDR)",
    imgTitle: "سامانه‌های شناسایی و پاسخ (XDR)",
  },
  {
    title: "سامانه‌های حفاظت پیرامونی",
    specialChar: "(IDS/IPS)",
    desc: "سامانه‌های تشخیص نفوذ و پاسخ خودکار برای شناسایی در لحظه و جلوگیری از نفوذ با پایش دقیق ترافیک شبکه، تحلیل الگوهای حمله و اعمال سیاست‌های حفاظتی برای جلوگیری از تهدیدات در سطح کاربران و سرورها",
    logo: "monitor.svg",
    imgAlt: "سامانه‌های حفاظت پیرامونی (DLP)",
    imgTitle: "سامانه‌های حفاظت پیرامونی (DLP)",
  },
  {
    title: "سامانه‌ محافظت از اطلاعات",
    specialChar: "(DLP)",
    desc: "کنترل و نظارت هوشمند بر جریان داده‌های در حال عبور روی شبکه یا داده‌های در حال استراحت (at-rest) و  ترافیک ورودی‌و‌خروجی ایمیل‌‌ها، فایل‌سرورها و... با هدف شناسایی انتقال‌های غیرمجاز و جلوگیری از خروج اطلاعات حساس سازمانی",
    logo: "centralized.svg",
    imgAlt: "سامانه‌ محافظت از اطلاعات (DLP)",
    imgTitle: "سامانه‌ محافظت از اطلاعات (DLP)",
  },
  {
    title: "تحلیل رفتار کاربران و تهدیدات",
    specialChar: "(Threat Intelligence)",
    desc: "شناسایی و تحلیل الگوهای غیرعادی و تهدیدات پیشرفته از طریق رفتار کاربران (UBA) یا بررسی عملکرد تجهیزات (UBEA) و بررسی تغییرات در سیاست‌های امنیتی برای پیشگیری، هشداردهی و پاسخ سریع به رخدادهای امنیتی در کل زیرساخت سازمانی",
    logo: "enterprise.svg",
    imgAlt: "تحلیل رفتار کاربران و تهدیدات (Threat Intelligence)",
    imgTitle: "تحلیل رفتار کاربران و تهدیدات (Threat Intelligence)",
  },
  {
    title: "پنل مدیریتی",
    specialChar: "(Monitoring & Reporting)",
    desc: "نمایش بلادرنگ وضعیت امنیتی از طریق پنل‌های مدیریتی، تولید گزارش‌های تحلیلی دوره‌ای و پیشرفته و پشتیبانی از تصمیم‌گیری سریع و هوشمند در مدیریت رخدادها و برنامه‌ریزی اقدامات پیشگیرانه",
    logo: "configuration.svg",
    imgAlt: "پنل مدیریتی (Monitoring & Reporting)",
    imgTitle: "پنل مدیریتی (Monitoring & Reporting)",
  },
];

export const securityItems = [
  {
    title: "1. شناسایی",
    desc: "پایش ۲۴ ساعته ترافیک شبکه و بررسی لاگ‌ها برای شناسایی سریع رفتارهای مشکوک و تهدیدات اولیه",
    logo: "iam.svg",
    alt: "پایش ۲۴ ساعته ترافیک شبکه و بررسی لاگ‌ها برای شناسایی سریع رفتارهای مشکوک و تهدیدات اولیه",
  },
  {
    title: "2. تحلیل",
    desc: "تحلیل عمیق رخدادها برای کشف ریشه تهدید و ارزیابی سطح آسیب‌پذیری با تکیه بر سامانه‌های تحلیل رفتار ",
    logo: "sandbox.svg",
    alt: "تحلیل عمیق رخدادها برای کشف ریشه تهدید و ارزیابی سطح آسیب‌پذیری با تکیه بر سامانه‌های تحلیل رفتار ",
  },
  {
    title: "3. واکنش",
    desc: "واکنش سریع برای حذف یا قرنطینه تهدید، بازیابی سرویس‌ها و کاهش تاثیر حمله پیش از گسترش آن",
    logo: "siem.svg",
    alt: "واکنش سریع برای حذف یا قرنطینه تهدید، بازیابی سرویس‌ها و کاهش تاثیر حمله پیش از گسترش آن",
  },
  {
    title: "4. گزارش‌ ",
    desc: "ارائه گزارش‌های تحلیلی برای مدیریت و بازنگری سیاست‌های امنیتی به‌منظور ارتقای تاب‌آوری",
    logo: "dmz.svg",
    alt: "ارائه گزارش‌های تحلیلی برای مدیریت و بازنگری سیاست‌های امنیتی به‌منظور ارتقای تاب‌آوری",
  },
];

export const cdnCoverage = [
  {
    title: "52 هزار",
    cap: "کاهش میانگین زمان واکنش به رخدادهای امنیتی در مقابل فقدان SOC",
  },
  {
    title: "80٪",
    cap: "پوشش نقشه جهانی حملات MITRE ATT&CK",
  },
  {
    title: "500",
    cap: "سناریو (Use Case) چند مرحله‌ای پیچیده در SIEM",
  },
  {
    title: "بیش از 80",
    cap: "تعداد سناریوهای تحلیلی مبتنی بر رفتار کاربران(UBA)",
  },
];

export const popularServices = [
  {
    title: "شبکه توزیع محتوا (CDN)",
    desc: "با استفاده از CDN، امنیت و سرعت بارگذاری وب‌سایت خود را بهبود دهید. داده‌های شما از طریق سرورهای توزیع‌شده همیشه نزدیک‌تر به کاربران خواهند بود.",
    logo: "CloudGuard-Service.svg",
    route: "/cdn",
    imgAlt: "شبکه توزیع محتوا (CDN)",
    imgTitle: "شبکه توزیع محتوا (CDN)",
  },
  {
    title: "PAM ابری آبالون",
    desc: "با استفاده از راهکار PAM ابری آبالون، بدون نیاز به زیرساخت داخلی، دسترسی کاربران به سیستم‌عامل‌ها و نرم‌افزارهای سازمانی را به‌صورت ایمن و متمرکز مدیریت و تمام فعالیت‌ها را ثبت و کنترل کنید.",
    logo: "DNS.svg",
    route: "/pam",
    imgAlt: "PAM ابری آبالون",
    imgTitle: "PAM ابری آبالون",
  },
  {
    title: "ابر ایزوله آبالون",
    desc: "با سرویس ابر ایزوله آبالون از زیرساخت سازمان خود، بر بستر امن و ایزوله از اینترنتِ نورونتا، به منابع نامحدود ابری آبالون متصل شوید. گویی اینکه همه تجهیزات، یکجا و در سازمان شما مستقر شده‌اند.",
    logo: "CloudGuard-Service.svg",
    route: "/isolated-cloud",
    imgAlt: "سرویس ابر ایزوله آبالون",
    imgTitle: "سرویس ابر ایزوله آبالون",
  },
  {
    title: "خدمات دواپس آبالون",
    desc: "بدون نیاز به استخدام نیروی داخلی، متخصصان ابری آبالون به تیم فنی سازمان شما می‌پیوندند تا تا مسیر رشد را با شتاب و بدون دغدغه طی کنید.",
    logo: "DNS.svg",
    route: "/devops",
    imgAlt: "خدمات دواپس آبالون",
    imgTitle: "خدمات دواپس آبالون",
  },
];

export const questions = [
  {
    title: "راهکار SOC آبالون چیست؟",
    answer:
      "راهکار SOC آبالون مجموعه‌ای از ابزارهای امنیتی پیشرفته شامل SIEM، XDR، IDS/IPS، DLP و سیستم‌های تحلیل رفتار کاربران (UBA/UBEA) است که می‌تواند به‌صورت مستقل روی زیرساخت داخلی سازمان یا در دیتاسنترهای آبالون مستقر شود. با بهره‌گیری از فرآیندهای چندمرحله‌ای، این راهکار نظارت، تحلیل و واکنش به تهدیدات امنیتی را به‌صورت متمرکز و جامع فراهم می‌کند.",
  },
  {
    title:
      "آیا امکان خرید و استقرار ابزارهای SOC به‌صورت مستقل از خدمات مدیریت‌شده وجود دارد؟",
    answer:
      "بله، سازمان‌ها می‌توانند ابزارهای بومی SOC مانند SIEM، XDR و IDS یا IPS را به‌صورت مستقل تهیه و روی زیرساخت داخلی یا دیتاسنترهای آبالون پیاده‌سازی کنند. در این حالت، مدیریت عملیات امنیت بر عهده تیم فنی داخلی سازمان خواهد بود.",
  },
  {
    title: "خدمات SOC مدیریت‌شده آبالون شامل چه مواردی است؟",
    answer:
      "در مدل مدیریت‌شده، تیم SOC آبالون مسئولیت پایش مداوم، تحلیل تهدیدات، واکنش به رخدادها، تهیه گزارش‌های تحلیلی و به‌روزرسانی فرآیندهای امنیتی را بر عهده دارد. این خدمات به‌صورت ۲۴ ساعته از طریق مرکز عملیات امنیت آبالون ارائه می‌شود.",
  },
  {
    title:
      "راهکار SOC آبالون چگونه تهدیدات پیچیده و ناشناخته را شناسایی می‌کند؟",
    answer:
      "راهکار SOC آبالون با ترکیب تحلیل داده‌های SIEM و XDR، پایش لحظه‌ای شبکه و نقاط پایانی، تحلیل رفتار کاربران (UBA/UBEA) و استفاده از پایگاه داده تهدیدات به‌روز، می‌تواند الگوهای غیرعادی و تهدیدات چندمرحله‌ای را شناسایی کرده و به‌صورت سریع و متمرکز واکنش نشان دهد. این رویکرد جامع، امکان مقابله با تهدیدات پیشرفته و ناشناخته را برای سازمان فراهم می‌کند.",
  },
];
